import { render } from "./DetailComponent2Update.vue?vue&type=template&id=0c0effd9&scoped=true"
import script from "./DetailComponent2Update.vue?vue&type=script&lang=js"
export * from "./DetailComponent2Update.vue?vue&type=script&lang=js"

import "./DetailComponent2Update.vue?vue&type=style&index=0&id=0c0effd9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c0effd9"]])

export default __exports__